<dialog-wrapper
  [disabled]="false"
  [smallTitle]="true"
  [dialogTitle]="'Asset icon'"
  [hideBottom]="true"
  [titleHeight]="40"
  [giveMeTwenty]="true"
  [dontGiveExtraSpacing]="true"
  [showClose]="true"
  (close)="dialogRef.close()"
>
  <toggle-button [selected]="data.selectedIconId === icon" *ngFor="let icon of data.iconChoices" (select)="selectIcon(icon)">
    <asset-card [asset]="{ icon: icon, name: data.nameMap[icon] }"></asset-card>
  </toggle-button>

</dialog-wrapper>
